(function () {
  var SIRET_REGEX = /^\d{14}$/;
  var TVA_COUNTRIES = ['AT','BE','BG','CY','CZ','DE','DK','EE','EL','ES','FI','FR','HR','HU','IE','IT','LT','LU','LV','MT','NL','PL','PT','RO','SE','SI','SK'];
  var OBSERVER_TIMEOUT = 15000;

  function luhnCheck(digits) {
    var sum = 0;
    for (var i = digits.length - 1; i >= 0; i--) {
      var n = parseInt(digits[i], 10);
      if ((digits.length - i) % 2 === 0) {
        n *= 2;
        if (n > 9) n -= 9;
      }
      sum += n;
    }
    return sum % 10 === 0;
  }

  function validateSIRET(value) {
    var cleaned = value.replace(/\s/g, '');
    return SIRET_REGEX.test(cleaned) && luhnCheck(cleaned);
  }

  function validateTVA(value) {
    value = value.replace(/\s/g, '').toUpperCase();
    var country = value.substring(0, 2);
    var rest = value.substring(2);
    if (TVA_COUNTRIES.indexOf(country) === -1) return false;
    if (country === 'FR') return /^[0-9A-Z]{2}\d{9}$/.test(rest);
    return /^[0-9A-Z]{2,13}$/.test(rest);
  }

  var MESSAGES = {
    siret: 'Le numéro SIRET doit contenir exactement 14 chiffres valides.',
    tva: 'Format TVA invalide. Exemple : FR12345678901, DE123456789.'
  };

  function isVisible(el) {
    if (!el) return false;
    if (el.offsetParent === null && window.getComputedStyle(el).position !== 'fixed') return false;
    return window.getComputedStyle(el).display !== 'none';
  }

  function setError(control, message) {
    var input = control.querySelector('input');
    var msg = control.querySelector('.messages');
    if (input) input.classList.add('error');
    if (msg) msg.textContent = message;
  }

  function clearError(control) {
    var input = control.querySelector('input');
    var msg = control.querySelector('.messages');
    if (input) input.classList.remove('error');
    if (msg) msg.textContent = '';
  }

  function validateField(control, validatorFn, message) {
    if (!isVisible(control)) return true;
    var input = control.querySelector('input');
    if (!input) return true;
    var value = input.value;
    if (value && !validatorFn(value)) {
      setError(control, message);
      return false;
    }
    clearError(control);
    return true;
  }

  function cleanInputValue(control) {
    var input = control ? control.querySelector('input') : null;
    if (input) input.value = input.value.replace(/\s/g, '');
  }

  function setupValidation(form) {
    var siretControl = form.querySelector('[data-element-id="text-3"]');
    var tvaControl = form.querySelector('[data-element-id="text-4"]');

    var fields = [
      { c: siretControl, fn: validateSIRET, m: MESSAGES.siret },
      { c: tvaControl,   fn: validateTVA,   m: MESSAGES.tva }
    ];

    fields.forEach(function (f) {
      if (!f.c) return;
      f.c.querySelector('input').addEventListener('input', function () {
        validateField(f.c, f.fn, f.m);
      });
    });

    form.addEventListener('submit', function (e) {
      cleanInputValue(siretControl);
      cleanInputValue(tvaControl);

      var siretOk = validateField(siretControl, validateSIRET, MESSAGES.siret);
      var tvaOk   = validateField(tvaControl,   validateTVA,   MESSAGES.tva);

      if (!siretOk || !tvaOk) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var first = !siretOk ? siretControl : tvaControl;
        if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var timer;
    var observer = new MutationObserver(function (_, obs) {
      var form = document.querySelector('.globo-form-app[data-id="54771"] form');
      if (form && form.querySelector('[data-element-id="text-3"]')) {
        clearTimeout(timer);
        obs.disconnect();
        setupValidation(form);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    timer = setTimeout(function () {
      observer.disconnect();
    }, OBSERVER_TIMEOUT);
  });
})();
